import { lazy } from 'react';
import { authRoles } from 'app/auth';

const TmpBroadcastingPage = lazy(() => import('./TmpBroadcastingPage'));

const TmpBroadcastingConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'broadcasting',
      element: <TmpBroadcastingPage />,
    },
  ],
};

export default TmpBroadcastingConfig;
